<template>
    <div>
        <h1 style="font-size: 24px; color: black;">投放报告数据</h1>
        <el-card class="form-container" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="100px">
                <el-form-item label="日期：">
                    <el-date-picker
                        v-model="queryData.timeDate"
                        type="daterange"
                        :clearable="false"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>&emsp;&emsp;
                </el-form-item>
                <el-form-item label=" " class="sub-sub10">
                    <el-button type="primary" @click="query">查询</el-button>
                    <el-button type="primary" @click="downloadData">导出</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <div style="margin-top: 20px">
            <el-table :data="dataList"
                      style="width: 100%"
                      border
                      :header-cell-style="{background:'#303133'}"
                      element-loading-text="拼命加载中"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      v-loading="loading">
                <el-table-column label="时间" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.dt | dateFormat }}
                    </template>
                </el-table-column>
                <el-table-column label="广告主" prop="name" align="center"></el-table-column>
                <el-table-column label="消耗" prop="c" align="center"></el-table-column>
                <el-table-column label="新增" prop="a" align="center"></el-table-column>
            </el-table>
        </div>
        <div>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,50,100]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {report} from "@/http/outApi";
import settingMix from '@/utils/mix/common-setting'
import utils from '@/utils'
import Export from '@/utils/ExportData'
import {commonFilter1, dateFormat} from "../../filters";

export default {
    name: "ProxyDataReport",
    mixins: [settingMix],
    data() {
        return {
            queryData: {
                mediaId: -1,
                timeDate: ['', ''],
                appId: -1
            },
            page: {
                size: 100,
                page: 1,
                totalElements: null
            },
            mediaType: 2,
            needGetApp: true,
            needGetMedia: true,
            dataList: [],
            loading: true,
            appList: [],
            mediaObj: {},
            excelHeaders: [
                {dt: '时间'},
                {name: '广告主'},
                {c: '消耗'},
                {a: '新增'}
            ]
        }
    },
    methods: {
        formatDate: function (column, format) {
            return utils.DateUtil.formatDate(column, format)
        },
        handleSizeChange(size) {
            this.page.size = size;
            this.query();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.query();
        },
        query() {
            this.queryData.page = this.page.page;
            this.queryData.size = this.page.size;
            if (this.queryData.timeDate === null) {
                this.queryData.timeDate = ['', ''];
            }
            this.queryData.startDt = this.queryData.timeDate[0] === '' ? null : this.queryData.timeDate[0];
            this.queryData.endDt = this.queryData.timeDate[1] === '' ? null : this.queryData.timeDate[1];
            this.loading = true;
            report(this.queryData).then(resp => {
                if (resp.data.status === 0) {
                    this.loading = false;
                    this.dataList = resp.data.info.list;
                    this.page.totalElements = resp.data.info.total;
                }
            });
        },
        downloadData() {
            if (this.queryData.timeDate === null) {
                this.queryData.timeDate = ['', ''];
            }
            this.queryData.startDt = this.queryData.timeDate[0] === '' ? null : this.queryData.timeDate[0];
            this.queryData.endDt = this.queryData.timeDate[1] === '' ? null : this.queryData.timeDate[1];
            this.loading = true;
            report(Object.assign(this.queryData, {size: 100000, page: 1})).then(resp => {
                if (resp.data.status === 0) {
                    this.loading = false;
                    // this.dataList=resp.data.info.list;
                    // this.page.totalElements =resp.data.info.total;
                    resp.data.info.list.forEach(item => {
                        item.dt = dateFormat(item.dt)
                        item.mediaId = commonFilter1(item.mediaId, this.mediaObj)
                        item.appId = commonFilter1(item.appId, this.appObj)
                    })
                    Export.downloadExl(resp.data.info.list, '投放报告', this.excelHeaders)
                }
            });
        }
    },
    created() {
        this.query();
    }
}
</script>

<style scoped>

</style>